import RoundTab from './RoundTab';

export default RoundTab;
